export default function initDesktopSubmenu() {
    // Legacy no-op kept for compatibility; menu is now a single full-screen overlay.
}
